var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountNoPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.001,
    height: 44,
    viewBox: "0 0 44.001 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M-4225,1178a21.868,21.868,0,0,1-8.564-1.729,21.928,21.928,0,0,1-6.993-4.715,21.922,21.922,0,0,1-4.715-6.993A21.853,21.853,0,0,1-4247,1156a21.855,21.855,0,0,1,1.729-8.564,21.917,21.917,0,0,1,4.715-6.993,21.926,21.926,0,0,1,6.993-4.715A21.87,21.87,0,0,1-4225,1134a21.87,21.87,0,0,1,8.564,1.729,21.926,21.926,0,0,1,6.993,4.715,21.917,21.917,0,0,1,4.715,6.993A21.855,21.855,0,0,1-4203,1156a21.853,21.853,0,0,1-1.729,8.563,21.922,21.922,0,0,1-4.715,6.993,21.928,21.928,0,0,1-6.993,4.715A21.868,21.868,0,0,1-4225,1178Zm.3-16a18.218,18.218,0,0,0-9.687,2.774,18.269,18.269,0,0,0-5.21,4.9,19.927,19.927,0,0,0,6.508,4.62A19.834,19.834,0,0,0-4225,1176a19.84,19.84,0,0,0,8.317-1.806,19.914,19.914,0,0,0,6.611-4.886,18.307,18.307,0,0,0-4.938-4.534A18.231,18.231,0,0,0-4224.7,1162Zm-.3-18a8.01,8.01,0,0,0-8,8,8.009,8.009,0,0,0,8,8,8.008,8.008,0,0,0,8-8A8.009,8.009,0,0,0-4225,1144Z",
    transform: "translate(4247 -1134)",
    fill: "#233155",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNoPicture);
export default __webpack_public_path__ + "static/media/account-no-picture.66fd1c0f54f156dd92fedd5589e946a9.svg";
export { ForwardRef as ReactComponent };